import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import YouTubeEmbed from "../../../components/Banner/YouTubeEmbed";
import HeaderBread from "../../../components/HeaderBread";
import SelectLocation from "../../../components/LocationFilter";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SearchField from "../../../components/SearchField";
import ActiveInactive from "../../../components/UI/ActiveInactive";
import CustomizedDragNDrop from "../../../components/UI/CustomizedDragNDrop";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { constants } from "../../../constants/constants";
import ValidDateUI from "../../../constants/validDateUI";
import { getAllLocations } from "../../../utils/ApiCalls/Locations";

import {
  deleteBannerData,
  getBannerData,
  updateBannerData,
  updatePosition,
} from "../../../utils/ApiCalls/Banner";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { checkPermission } from "../../../utils/Validation/checkPermission";

import ActiveSwitchFile from "../../../components/SwitchFile";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

const Banner = () => {
  const navigate = useNavigate();
  const [{ userDetails, permission }] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Banner List",
      route: "/website/cms/homepage/banner",
    },
  ];
  const [active, setActive] = useState("listing");
  const [regionalActive, setRegionalActive] = useState("SG");
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [, dispatch] = useDataLayerValue();
  const [sort, setSort] = useState("");
  const [columns, setColumns] = useState([]);
  const [order, setOrder] = useState("");
  const [status, setStatus] = useState("");
  const [refreshlog, setRefreshLog] = useState(true);
  const [location, setLocation] = useState();
 const [locationOption, setLocationOption] = useState([]);

  
    const locationP = useLocation();
  
    const [page, setPage] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
    );
    const [pageSize, setPageSize] = useState(
      () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
    );
    const [search, setSearch] = useState(
      () => new URLSearchParams(locationP.search).get("search") || ""
    );
  
    useEffect(() => {
      const params = new URLSearchParams(locationP.search);
      const pageParam = parseInt(params.get("page")) || 1;
      const pageSizeParam = parseInt(params.get("pageSize")) || 10;
      const searchParam = params.get("search") || "";
  
      // setPage(pageParam);
      // setPageSize(pageSizeParam);
      setSearch(searchParam);
    }, [locationP.search]);
  
    useEffect(() => {
      const params = new URLSearchParams();
      const currentParams = new URLSearchParams(locationP.search);
  
      params.set("page", page);
      params.set("pageSize", pageSize);
      if (search) params.set("search", search);
  
      if (currentParams.toString() !== params.toString()) {
        navigate({ search: params.toString() }, { replace: true });
      }
    }, [page, pageSize, search, navigate, locationP.search]);
  

  const sortHandler = async (options) => {
    if (Object.keys(options).length > 0) {
      let sort, order;
      sort = options.columnKey;
      order =
        options.order === "ascend"
          ? "asc"
          : options.order === "descend"
          ? "desc"
          : undefined;
      setSort(sort);
      setOrder(order);
      await getData(page, sort, order);
    }
  };

  const setPositionalValue = (data) => {};

  const updateBannerPosition = async (banners) => {
    if (checkPermission(permission, "update_per", "Banner",window?.location?.pathname)) {
      try {
        let args = { search: search, page: page, limit: pageSize };
        if (regionalActive) {
          args = { ...args, location: regionalActive };
        }
        if (status !== "") {
          args = { ...args, is_active: status };
        }

        const data = await updatePosition(banners, args);
        addlog(
          "Banner Position Updated",
          "Banner",
          { location_id: banners[0].location_id },
          userDetails.id
        );
        if (data.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.error,
          });
        } else if (data.data) {
          setRows(data.data);
          setCount(data.count);
          setPositionalValue(data.data);
        }
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    } else {
      message.error("Update permission missing");
    }
  };

  useEffect(() => {
    getData(page, sort, order);
  }, [page, pageSize, search]);

  useEffect(() => {
     getLocationData();
   }, []);

  const getLocationData = async () => {
     let data = await getAllLocations();
     setLocationOption(data?.data || []);
  };
  useEffect(() => {
    setColumns([
      {
        title: "Dno",
        width: 10,
        dataIndex: "id",
        key: "position",
        fixed: "left",
        render: (position, record, index) => (page - 1) * pageSize + index + 1,
      },
      {
        title: "Image",
        width: 30,
        dataIndex: "image",
        key: "image",
        render: (image, record) => {
          const displayImage =
            image ||
            record.simplified_chinese_image ||
            record.traditional_chinese_image ||
            record.bahasa_image;
          if (record.content_type === "video") {
            return (
              <video
                src={`${constants.MEDIAURL}/${displayImage}`}
                style={{ width: "100px", height: "80px" }}
              >
                <track kind="captions" src="" label="English captions" />
              </video>
            );
          } else if (record.content_type === "link") {
            return (
              <YouTubeEmbed
                videoUrl={`${constants.MEDIAURL}/${displayImage}`}
                width="100px"
                height="80px"
              />
            );
          } else {
            return (
              <img
                alt="banner"
                src={`${constants.MEDIAURL}/${displayImage}`}
                style={{ width: "100px", height: "80px" }}
              />
            );
          }
        },
      },
      {
        title: "Valid date",
        dataIndex: "valid_date",
        key: "valid_till",
        width: 10,

        render: (text, record, index) => {
          return (
            <ValidDateUI
              regionalActive={regionalActive}
              locationOption={locationOption}
              time
              record={record}
              handleUpdate={handleUpdate}
            />
          );
        },
      },
      {
        title: "Title",
        dataIndex: "title",
        key: "english_title",
        sorter: (a, b) => "",
        width: 400,
        render: (text, record, index) => (
          <p dangerouslySetInnerHTML={{ __html: text }} />
        ),
      },
      {
        title: "Display Location",
        dataIndex: "location",
        key: "location",
        width: 20,
        sorter: (a, b) => "",
        render: (item) => <p>{item.location_name}</p>,
      },

      {
        title: "Status",
        dataIndex: "is_active",
        key: "is_active",
        width: 30,
        sorter: (a, b) => "",
        render: (item, record, index) => (
          <ActiveSwitchFile
            item={item}
            record={record}
            index={index}
            handleUpdate={handleUpdate}
          />
        ),
      },

      {
        title: "Action",
        key: "operation",
        width: 30,
        render: (text, record) => (
          <div className="table_action_btn">
            <button className="btn" onClick={() => handleEdit(record.id)}>
              <i
                className="ri-edit-2-line"
                data-toggle="tooltip"
                title="Edit"
              ></i>
            </button>

            <DeletePop
              onConfirm={() =>
                handleDelete(record.id, record.title, record.location_id)
              }
            >
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        ),
      },
    ]);
  }, [page, pageSize, regionalActive, location, status, rows,search]);
  useEffect(() => {
    getData(page, sort, order);
  }, [regionalActive]);

  const getData = async (value, sort, order) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let args = { search: search, page: value, limit: pageSize };
    if (regionalActive) {
      args = { ...args, location: regionalActive };
    }
    if (location && location != -1) {
      args = { ...args, location_id: location };
    }
    if (status !== "") {
      args = { ...args, is_active: status };
    }
    if (order) {
      if (sort) {
        args = { ...args, sort };
      }
      args = { ...args, order };
    }

    let data = await getBannerData(args);
    if (data.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setPositionalValue(data.data);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const handleEdit = async (id) => {
    if (checkPermission(permission, "update_per", "Banner",window?.location?.pathname)) {
      navigate("/website/cms/homepage/banner/edit/" + id);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDelete = async (id, title, location_id) => {
    if (checkPermission(permission, "delete_per", "Banner",window?.location?.pathname)) {
      await deleteBannerData(id);
      addlog(
        "Banner Deleted",
        "Banner",
        { id, title, location_id },
        userDetails.id
      );
      setRefreshLog((item) => !item);
      getData(page, sort, order);
    } else {
      message.error("Missing Permission for delete ");
    }
  };

  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "Banner",window?.location?.pathname)) {
      let data = await updateBannerData(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Banner " +
            (!values.valid_from
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          "Banner",
          { ...values, id, title, location_id },
          userDetails.id
        );
      }
      setRefreshLog((item) => !item);
      getData(page, sort, order);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"banner"}>
      <CustomHeaderTitle title={"Banner"} />

      <div>
        <div>
          <HeaderBread navigation={navigation} title={"Banner"}></HeaderBread>
        </div>

        <section className="content" style={{ marginTop: "20px" }}>
          <div
            style={{
              display: "flex",

              flexDirection: "column",
            }}
          ></div>
          <div className="container-fluid">
            {" "}
            <SwitchBar
              tabs={[
                { title: "Banner List", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Banner List</h5>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      width: "80%",
                      justifyContent: "flex-end",
                    }}
                  >
                    {regionalActive == "OTHER" && (
                      <SelectLocation
                        getData={getData}
                        setStatus={setLocation}
                        disabled={regionalActive == "OTHER"}
                        status={location}
                        width={200}
                        setPage={setPage}
                      />
                    )}
                    <ActiveInactive
                      width={200}
                      getData={getData}
                      setStatus={setStatus}
                      status={status}
                      setPage={setPage}
                    />
                    <Link
                      to="/website/cms/homepage/banner/add"
                      className="btn add_v_btn"
                      style={{ width: "200px" }}
                    >
                      Add Banner
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div style={{ maxWidth: 200 }}>
                        <SearchField
                          value={search}
                          SearchValue={() => {
                            setPage(page);
                          }}
                          setValue={(e) => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <SwitchBar
                      tabs={[
                        { title: "Singapore", value: "SG" },
                        { value: "MY", title: "Malaysia" },
                        { value: "ID", title: "Indonesia" },
                        { value: "IN", title: "India" },
                        { value: "CN", title: "China" },
                        { value: "TW", title: "Taiwan" },
                        { value: "HK", title: "Hong Kong" },
                        { value: "PH", title: "Philippines" },
                        { value: "AE", title: "UAE" },

                        { value: "OTHER", title: "All Others" },
                      ]}
                      setPageSize={setPageSize}
                      module={"country-tab"}
                      setPage={setPage}
                      setRows={setRows}
                      setCount={setCount}
                      activeTab={regionalActive}
                      setActiveTab={(item) => {
                        setRegionalActive(item);
                        setLocation();
                      }}
                      setSearch={setSearch}
                    />
                    {rows && columns && (
                      <CustomizedDragNDrop
                        setRows={setRows}
                        setPageSize={setPageSize}
                        setPage={setPage}
                        pageSize={pageSize}
                        page={page}
                        count={count}
                        columns={
                          regionalActive !== "OTHER"
                            ? columns.filter((c) => c.key !== "location")
                            : columns
                        }
                        rows={rows}
                        title={"Banner"}
                        sortHandler={sortHandler}
                        updatePosition={updateBannerPosition}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}{" "}
          </div>
        </section>

        {active === "logs" && (
          <Logs
            type={"Banner"}
            slug={"/website/cms/homepage/banner/edit/"}
            refreshlog={refreshlog}
          />
        )}
      </div>
    </Layout>
  );
};

export default Banner;
